<template>
    <div class="purchase">
        <div class="block">
            <div class="subscription-plan-data">
                <div class="subscription-plan-container">
                    <PurchaseOption
                            :showCurrency="showCurrency"
                            :purchaseOption="purchaseOptionToShow"
                            :selected="true"
                    />
                </div>
                <div class="text" v-if="promotionalCode">
                    <h4 class="commercial">
                        {{promotionalCode.commercial_text}}
                    </h4>
                    <p class="legal">
                        {{promotionalCode.legal_text}}
                    </p>
                </div>
            </div>

            <PurchaseOptionLegals
                    :purchaseOption="purchaseOptionToShow"
                    :showCurrency="showCurrency"
                    :include-option-description="true"
            />

            <p class="currency-disclaimer">
                {{$t('subscription.currency_disclaimer', {currency_description: showCurrency.description, currency_code: showCurrency.code, currency_symbol: showCurrency.symbol})}}
            </p>

            <div class="buttons-container">
                <button type="button" class="btn back" @click="backHandler">
                    {{$t('subscription.buttons.back')}}
                </button>
            </div>

            <template  v-if="subscriptionPlan">
                <div class="payment-methods-container">
                    <template v-if="subscriptionPlan.payment_methods.data.length > 1">
                        <PaymentMethodGroup
                            v-if="subscriptionPlan.payment_methods.data.some(payment_method => payment_method.group === 'recommended')"
                            :type="'recommended'"
                            :selected-payment-method="selectedPaymentMethod"
                            :payment-methods="subscriptionPlan.payment_methods.data.filter(payment_method => payment_method.group === 'recommended')"
                            @click="setPaymentMethod"
                        />
                        <PaymentMethodGroup
                            v-if="subscriptionPlan.payment_methods.data.some(payment_method => payment_method.group === 'others')"
                            :type="'others'"
                            :selected-payment-method="selectedPaymentMethod"
                            :payment-methods="subscriptionPlan.payment_methods.data.filter(payment_method => payment_method.group === 'others')"
                            @click="setPaymentMethod"
                        />
                        <PaymentMethodGroup
                            v-if="subscriptionPlan.payment_methods.data.some(payment_method => payment_method.group === 'try-again')"
                            :type="'try-again'"
                            :selected-payment-method="selectedPaymentMethod"
                            :payment-methods="subscriptionPlan.payment_methods.data.filter(payment_method => payment_method.group === 'try-again')"
                            @click="setPaymentMethod"
                        />
                    </template>
                    <template v-else-if="subscriptionPlan.payment_methods.data.length === 1">
                        <div class="single-payment-method">
                            <h5 class="action">
                                {{$t('subscription.buttons.pay_using')}}
                            </h5>
                            <div
                                    class="payment-method-img"
                                    :style="{backgroundImage: `url('${selectedPaymentMethod.image_url}')`}"
                            >
                            </div>
                        </div>
                    </template>
                    <div v-else>
                        <template v-if="code">
                            {{$t('subscription.promotional_code.invalid', {code: code})}}
                        </template>
                        <template v-else>
                          <div class="no-payment-methods-available">
                            {{$t('subscription.no_payment_methods_available')}}
                          </div>
                        </template>
                    </div>
                </div>

            </template>
            <hr class="separator"/>
        </div>
        <div class="block payment-form-container">
            <div
                    class="form-container"
                    v-if="formComponent"
            >
                <component
                        :is="formComponent"
                        :purchaseOption="purchaseOption"
                        :paymentMethod="selectedPaymentMethod"
                        :selectedCountry="selectedCountry"
                        :hasToAcceptNoTrial="hasToAcceptNoTrial"
                        :hasToAcceptNoPromo="hasToAcceptNoPromo"
                        :resultMessage="resultMessage"
                        @submit="submitHandler"
                        @loadingChange="loadingChange"
                />

                <!--
                <div class="result-message" v-if="resultMessage">
                    <p>
                        {{resultMessage}}
                    </p>
                </div>
                -->
            </div>
            <div class="form-none" v-else>
                <div class="square">
                    <h2
                      v-if="subscriptionPlan.payment_methods.data.length >= 1"
                    >
                        {{$t('subscription.select_payment_method')}}
                    </h2>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import resources from './../resources';
import Spinner from "./Spinner";
import PurchaseOption from './SubscriptionForm.PurchaseOption';
import PurchaseOptionLegals from "./PurchaseOptionLegals";
import PurchaseInovioPay from './SubscriptionForm.Purchase.InovioPay';
import PurchasePrePaidPromotionalCode from './SubscriptionForm.Purchase.PrePaidPromotionalCode';
import PurchaseMercadopagoBasicForm from './SubscriptionForm.Purchase.MercadopagoBasicForm';
import PurchaseTest from './SubscriptionForm.Purchase.Test';
import PurchaseCcbillFlexformForm from './SubscriptionForm.Purchase.CcbillFlexformForm';
import PaymentMethodGroup from "./PaymentMethodGroup";

export default {
        components: {
            PurchaseInovioPay,
            PurchaseCcbillFlexformForm,
            PurchaseMercadopagoBasicForm,
            PurchasePrePaidPromotionalCode,
            PurchaseTest,
            PurchaseOptionLegals,
            Spinner,
            PurchaseOption,
            PaymentMethodGroup,
        },
        props: {
            code: {
                required: false,
                default: null,
            },
            referal: {
                required: false,
                default: null,
            },
            purchaseOption: {
                type: Object,
                required: true,
                validator(purchaseOption){
                    if(purchaseOption.subscription_plan && purchaseOption.subscription_plan.data){
                        return purchaseOption.subscription_plan.data.hasOwnProperty('onward_subscription_plan');
                    }else{
                        return true;
                    }
                }
            },
            selectedCountry: {
                required: true,
            },
            showCurrency: {
                required: true,
            },
        },
        data(){
            return {
                selectedPaymentMethod: null,
                resultMessage: {
                    message: null,
                    redirect:null,
                    plan_id:null,
                },
                hasToAcceptNoTrial: null,
                hasToAcceptNoPromo: null,
                forcedPaymentMethod: this.$route.query.payment_method || false,
            }
        },
        created(){
          // fuerza el método de pago vía parametro en query
          // si el plan no tiene ese método de pago, pues que mal. yo les dije
          if(this.subscriptionPlan && this.forcedPaymentMethod)
          {
            this.selectedPaymentMethod = this.subscriptionPlan.payment_methods.data.find(payment_method => payment_method.key === this.forcedPaymentMethod.toLowerCase())
            if(this.selectedPaymentMethod){
                // quitando los otros métodos de pago
                // TODO: usar métodos
                this.subscriptionPlan.payment_methods.data.length = 1;
                this.subscriptionPlan.payment_methods.data[0] = this.selectedPaymentMethod;
                this.subscriptionPlan.payment_methods.data[0].director_cut = true;
                this.subscriptionPlan.payment_methods.data[0].director_cut_type = 'query-forced';
            }else{
                this.subscriptionPlan.payment_methods.data.length = 0;
            }
          }
            // si tiene un pago aprobado, lo preselecciono y quito los otros métodos de pago
            // solo si es el primer intento
            else if(
                this.subscriptionPlan &&
                this.subscriptionPlan.last_approved_payment &&
                this.subscriptionPlan.payment_methods.data.some(payment_method => payment_method.driver_front_key === this.subscriptionPlan.last_approved_payment) &&
                !this.failedCards
            ){
                this.selectedPaymentMethod = this.subscriptionPlan.payment_methods.data.find(payment_method => payment_method.driver_front_key === this.subscriptionPlan.last_approved_payment)
                // quitando los otros métodos de pago
                // TODO: usar métodos
                this.subscriptionPlan.payment_methods.data.length = 1;
                this.subscriptionPlan.payment_methods.data[0] = this.selectedPaymentMethod;
                this.subscriptionPlan.payment_methods.data[0].director_cut = true;
                this.subscriptionPlan.payment_methods.data[0].director_cut_type = 'last-payment-success';
            }
            // si tiene un métodos de pago que elegimos aquí => preseleccionamos el primero y quitamos los otros
            // opciones:
            // - inovio_pay
            // - ccbill_flexform
            // solo si es el primer intento
            // TODO: en algún momento mover al .env?
            else if(
                this.subscriptionPlan &&
                this.subscriptionPlan.payment_methods.data.some(payment_method => payment_method.driver_front_key === 'inovio_pay') &&
                !this.failedCards
            ){
                this.selectedPaymentMethod = this.subscriptionPlan.payment_methods.data.find(payment_method => payment_method.driver_front_key === 'inovio_pay')
                // quitando los otros métodos de pago
                // TODO: usar métodos
                this.subscriptionPlan.payment_methods.data.length = 1;
                this.subscriptionPlan.payment_methods.data[0] = this.selectedPaymentMethod;
                this.subscriptionPlan.payment_methods.data[0].director_cut = true;
                this.subscriptionPlan.payment_methods.data[0].director_cut_type = 'preselected-payment_method';
            }
            // Si solo hay un método de pago, lo preselecciono
            else if(this.subscriptionPlan && this.subscriptionPlan.payment_methods.data.length === 1){
                this.selectedPaymentMethod = this.subscriptionPlan.payment_methods.data[0];
            }
            // definir los métodos de pago en 3 grupos
            // - el último con el que se intentó y falló
            // - el recomendado que queda (se supone que solo hay 2)
            // - los demás
            else if(this.subscriptionPlan){
                this.subscriptionPlan.payment_methods.data.map(payment_method => {
                    if(payment_method.id === this.paymentFailed){
                        payment_method.group = 'try-again';
                    }else if(payment_method.id !== this.paymentFailed && payment_method.recommended === 1){
                        payment_method.group = 'recommended';
                    }else{ // (payment_method.id !== this.paymentFailed && payment_method.recommended === 0)
                        payment_method.group = 'others';
                    }
                })
            }
            // el else final sería para las promo prepagas, en ese caso no habría ningún this.subscriptionPlan
        },
        methods: {
            backHandler(event){
                this.$emit('back', event);
            },
            loadingChange(event){
                this.$emit('loadingChange', event);
            },
            submitHandler(formData){
                this.$emit('loadingChange', true);

                this.resultMessage.message  = null;
                this.resultMessage.redirect = null;

                resources.payments.store({
                    country_id: this.selectedCountry ? this.selectedCountry.id : 'INT',
                    form_data: formData,
                    payment_method_id: this.selectedPaymentMethod ? this.selectedPaymentMethod.id : null,
                    subscription_plan_id: this.purchaseOption.subscription_plan ? this.purchaseOption.subscription_plan.data.id : null,
                    promotional_code: this.purchaseOption.promotional_code ? this.purchaseOption.promotional_code.data.code : null,
                    referal: this.referal,
                }).then((resp) => {
                    setTimeout(() => {
                        this.$emit('loadingChange', false);
                        //Le damos tiempo, para que con el redirect no se vea que dejo de cargar, pero si hay un error en el redirect no rompemos el UI
                    }, 2500);

                    const redirect = resp.data.data.redirect;

                    if(redirect && redirect.url){
                        switch(redirect.method.toLowerCase()){
                            case 'get':

                                window.location.href = redirect.url;
                                return;

                            case 'post':
                                const redirectForm = document.createElement('form');
                                redirectForm.setAttribute('action', redirect.url);
                                redirectForm.setAttribute('method', 'post');
                                redirectForm.setAttribute('hidden', 'true');

                                if(redirect.fields){
                                    Object.keys(redirect.fields).forEach(key => {
                                        const fieldInput = document.createElement('input');
                                        fieldInput.setAttribute('type', 'hidden');
                                        fieldInput.setAttribute('name', key);
                                        fieldInput.setAttribute('value', redirect.fields[key]);
                                        redirectForm.appendChild(fieldInput);
                                    });
                                }else if(redirect.params){
                                    Object.keys(redirect.params).forEach(key => {
                                        const fieldInput = document.createElement('input');
                                        fieldInput.setAttribute('type', 'hidden');
                                        fieldInput.setAttribute('name', key);
                                        fieldInput.setAttribute('value', redirect.params[key]);
                                        redirectForm.appendChild(fieldInput);
                                    });
                                }

                                document.body.appendChild(redirectForm);
                                redirectForm.submit();
                                return;

                            default: throw new Error('Unknown method');
                        }
                    }else{
                        this.$router.push({name: 'dashboard'});
                    }

                    /*
                    this.hasToAcceptNoTrial = false;
                    this.hasToAcceptNoPromo = false;
                    */

                }).catch(err => {
                    this.$emit('loadingChange', false);

                    this.hasToAcceptNoTrial = false;
                    this.hasToAcceptNoPromo = false;

                    if(err.status === 422){
                        this.resultMessage.message = this.$t('subscription.messages.validation_error');
                    }else if(err.status === 409){
                        this.hasToAcceptNoTrial = true;
                        this.hasToAcceptNoPromo = true;
                    }else if(err.status === 410){
                        this.hasToAcceptNoPromo = true;
                    }else if(err.status === 411){
                        this.resultMessage.message = this.$t('subscription.messages.login_required.message');
                        this.resultMessage.redirect = 'login';
                    }else if(err.status === 412){
    
                        localStorage.setItem(
                            'paymentFailed',
                            this.subscriptionPlan.payment_methods.data.find(payment_method => payment_method.driver_front_key === 'ccbill_flexform').id
                        );

                        let failedCards =  JSON.parse(localStorage.getItem('failedCards')) || [];
                        let newFailedCard = {
                            "id":0,
                            "details":{
                                "TRANS_STATUS_NAME":"PENDING",
                                "TRANS_ID":null,
                                "SERVICE_ADVICE":null,
                                "INDUSTRY_ADVICE":null
                            }
                        }
                        
                        failedCards.push(newFailedCard);
                        localStorage.setItem('failedCards', JSON.stringify(failedCards));
    
    
                        // this.resultMessage.message = this.$t('subscription.messages.login_required.message');
                        this.resultMessage.message = 'Usted ya ha intentado un pago con éste procesador de pagos y no ha sido correcto. Si desea intentar con otro procesador de pagos';
                        this.resultMessage.redirect = 'home';
                        this.resultMessage.plan_id = this.purchaseOption.subscription_plan ? this.purchaseOption.subscription_plan.data.id : null;
                        
                    }else{
                        this.resultMessage.message = this.$t('subscription.messages.server_error');
                    }
                })
            },
            setPaymentMethod(paymentMethod){
                this.selectedPaymentMethod = paymentMethod;
                this.scrollToPaymentFormContainer();
            },
            scrollToPaymentFormContainer() {
                const el = this.$el.getElementsByClassName('payment-form-container')[0];
        
                if (el) {
                    el.scrollIntoView({behavior: 'smooth'});
                }
            },
        },
        computed: {
            purchaseOptionToShow(){
                let promotional_code = this.purchaseOption.promotional_code;

                if(this.purchaseOption.promotional_code && ((this.purchaseOption.promotional_code.data.type_is_free_trial && this.hasToAcceptNoTrial) || this.hasToAcceptNoPromo)){
                    promotional_code = null
                }

                return {
                    ...this.purchaseOption,
                    promotional_code,
                }
            },
            promotionalCode(){
                return this.purchaseOption.promotional_code ? this.purchaseOption.promotional_code.data : null;
            },
            subscriptionPlan(){
                return this.purchaseOption.subscription_plan ? this.purchaseOption.subscription_plan.data : null;
            },
            formComponent(){
                if(!this.selectedPaymentMethod){
                    if(this.promotionalCode && this.promotionalCode.type_is_pre_paid){
                        return 'PurchasePrePaidPromotionalCode';
                    }else{
                        return null;
                    }
                }else{
                    switch(this.selectedPaymentMethod.driver_front_key)
                    {
                        case 'test': return 'PurchaseTest';
                        case 'inovio_pay': return 'PurchaseInovioPay';
                        case 'mercadopago_basic': return 'PurchaseMercadopagoBasicForm';
                        case 'ccbill_flexform': return 'PurchaseCcbillFlexformForm';
                        default: throw Error(`Unknown driver key "${this.selectedPaymentMethod.driver_front_key}"`)
                    }
                }
            },
            failedCards(){
                return JSON.parse(localStorage.getItem('failedCards')) || false;
            },
            paymentFailed(){
                return JSON.parse(localStorage.getItem('paymentFailed')) || false;
            },
        },
        watch: {
            selectedPaymentMethod(){
                this.resultMessage.message  = null;
                this.resultMessage.redirect = null;
            },
            formComponent(){
                this.hasToAcceptNoTrial = false;
                this.hasToAcceptNoPromo = false;
            }
        }
    }
</script>
<style scoped lang="scss">
    @import './../styles/variables';
    @import './../styles/classes';

    .purchase{
        width: 100%;

        .separator{
            display: none;
        }

        .form-none{
            padding: 0 2em;

            .square{
                border-radius: 3px;
                display: flex;
                min-height: 200px;
                justify-content: space-around;
                box-shadow: 1px 1px 3px rgba(0,0,0,.35);
                align-items: center;
                color: $pallete_main_color;

            }
        }

        @media(max-width: 1150px){
            max-width: 500px;
            width: auto;
            min-width: auto;
            flex-direction: column;

            .block{
                width: 100%;
            }

            .separator{
                display: block;
            }

            .form-none{
                display: none;
            }
        }
    }

    .subscription-plan-data{
        .text{
            .commercial{
                text-align: center;
            }

            .legal{
                font-size: .8em;
            }
        }
    }

    .payment-methods-container{

        .single-payment-method{
            display: block;
            width: 75%;
            margin: 0 auto;
            
            .action{
                text-align: center;
                color: $pallete_secondary_color;
                margin: 1em 0;
                font-size: 2em;
                text-transform: uppercase;
            }

            .payment-method-img{
                display: block;
                margin-left: auto;
                margin-right: auto;
                width: 100%;
                height: 100px;
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
            }
        }
  
        .no-payment-methods-available{
          color: $pallete_main_color;
          text-align: center;
          margin-top: 50px;
          font-size: 1.3em;
        }
    }

    .form-container{
        margin-top: 30px;
        margin-bottom: 30px;
    }

    .buttons-container{
        margin-bottom: .5em;
        display: flex;
        justify-content: space-around;

        .btn.back{
            @extend %fresh-btn;
        }

        .btn.submit{
            background-color: $pallete_main_color;
            color: $pallete_clear_text_color;
        }
    }

    .result-message{
        text-align: center;
    }

    .payment-disclaimer{
        text-align: center;
        font-size: .75em;
    }
</style>